import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var registry = new Map();
export function addDecoder(cases, importFn) {
  if (!Array.isArray(cases)) {
    cases = [cases]; // eslint-disable-line no-param-reassign
  }

  cases.forEach(function (c) {
    return registry.set(c, importFn);
  });
}
export function getDecoder(_x) {
  return _getDecoder.apply(this, arguments);
}

// Add default decoders to registry (end-user may override with other implementations)
function _getDecoder() {
  _getDecoder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileDirectory) {
    var importFn, Decoder;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            importFn = registry.get(fileDirectory.Compression);
            if (importFn) {
              _context.next = 3;
              break;
            }
            throw new Error("Unknown compression method identifier: ".concat(fileDirectory.Compression));
          case 3:
            _context.next = 5;
            return importFn();
          case 5:
            Decoder = _context.sent;
            return _context.abrupt("return", new Decoder(fileDirectory));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDecoder.apply(this, arguments);
}
addDecoder([undefined, 1], function () {
  return import('./raw').then(function (m) {
    return m.default;
  });
});
addDecoder(5, function () {
  return import('./lzw').then(function (m) {
    return m.default;
  });
});
addDecoder(6, function () {
  throw new Error('old style JPEG compression is not supported.');
});
addDecoder(7, function () {
  return import('./jpeg').then(function (m) {
    return m.default;
  });
});
addDecoder([8, 32946], function () {
  return import('./deflate').then(function (m) {
    return m.default;
  });
});
addDecoder(32773, function () {
  return import('./packbits').then(function (m) {
    return m.default;
  });
});
addDecoder(34887, function () {
  return import('./lerc').then(function (m) {
    return m.default;
  });
});